module.exports = __webpack_public_path__ + "img/icon-s-house.c9d4bf1b.png";